import React from 'react';
import { STATS } from '../../../utils/homeData';
import { Stat } from '../../../types/HomeTypes';
import { useInView } from '../../../hooks/useInView';
import { useCountUp } from '../../../hooks/useCountUp';
import './StatsSection.scss';

function parseStat(value: string): { prefix: string; num: number; suffix: string } {
  const match = value.match(/^([^0-9]*)(\d+)(.*)$/);
  if (!match) return { prefix: '', num: 0, suffix: value };
  return { prefix: match[1], num: parseInt(match[2], 10), suffix: match[3] };
}

function StatItem({ stat, inView, index }: { stat: Stat; inView: boolean; index: number }) {
  const { prefix, num, suffix } = parseStat(stat.value);
  const count = useCountUp(num, 1400, inView);

  return (
    <div
      className={`stats-section__item animate-on-scroll${inView ? ' is-visible' : ''}`}
      style={{ transitionDelay: `${index * 0.12}s` }}
    >
      <div className="stats-section__value">
        {prefix}{count}{suffix}
      </div>
      <div className="stats-section__label">{stat.label}</div>
    </div>
  );
}

export function StatsSection() {
  const { ref, inView } = useInView<HTMLDivElement>({ threshold: 0.2 });

  return (
    <section className="stats-section">
      <div className="stats-section__grid" ref={ref}>
        {STATS.map((stat, index) => (
          <StatItem key={stat.label} stat={stat} inView={inView} index={index} />
        ))}
      </div>
    </section>
  );
}
